import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import slide1 from '../../assets/IMAGE01.png';
import slide2 from '../../assets/IMAGE02.jpg';
import slide3 from '../../assets/IMAGE03.png';
import slide4 from '../../assets/IMAGE04.png';
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";

const slides = [
    {
        image: slide1,
        subtitle: "Construction Management Solutions",
        title: "Construction Project Management",
        description: "We Plan, Coordinate, and Deliver Quality Building Projects on Time and Within Budget."
    },
    {
        image: slide2,
        subtitle: "Architectural Plans and Designs",
        title: "Architectural Solutions",
        description: "Creative, functional, and modern building designs tailored to your vision, lifestyle, and budget."
    },
    {
        image: slide3,
        subtitle: "Building Cost Estimations",
        title: "Cost Consultancy Solutions",
        description: "Accurate and detailed project cost estimates and BoQ to help you plan, budget, and build with confidence."
    },
    {
        image: slide4,
        subtitle: "MEP Schematic Designs",
        title: "MEP Solutions",
        description: "Professional mechanical, electrical, and plumbing designs that ensure efficiency, safety, functionality, and smooth building performance."
    }
];

const ProjectGallery = () => {
    return (
        <div className="w-full">
            <Carousel
                showThumbs={false}
                autoPlay={true}
                infiniteLoop={true}
                showStatus={false}
                className="rounded-lg shadow-lg"
            >
                {slides.map((slide, index) => (
                    <div key={index} className="relative h-[540px] md:h-[630px]">
                        <img
                            src={slide.image}
                            alt={slide.title}
                            className="w-full h-full object-cover"
                        />

                        <div className="absolute inset-0 bg-black/50"></div>
                        <div className="absolute inset-0 flex flex-col justify-center items-start text-left  container mx-auto px-9 md:px-2">
                            <p className="text-white uppercase font-semibold tracking-wider text-sm md:text-base">
                                {slide.subtitle}
                            </p>
                            <h3 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-3">
                                {slide.title}
                            </h3>
                            <p className="text-gray-200 max-w-lg text-sm md:text-base leading-relaxed">
                                {slide.description}
                            </p>
                            <Link to={'/about'} className="btn btn-secondary mt-6 flex items-center gap-2">
                                Explore Services <span><FaArrowRightLong /></span>
                            </Link>
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default ProjectGallery;